var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "svg",
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10.6301 6C11.1235 6 11.5986 6.1997 11.9692 6.55917L12.0772 6.67177L13.0881 7.80472C13.437 8.19574 13.6469 8.71341 13.6822 9.26133L13.6875 9.42652L13.6881 10.9948C14.4603 11.3325 15 12.1032 15 13V17.375C15 18.8247 13.8247 20 12.375 20H5.8125C5.08763 20 4.5 19.4124 4.5 18.6875V12.125C4.5 11.4001 5.08763 10.8125 5.8125 10.8125V8.14773C5.8125 6.96157 6.77407 6 7.96023 6H10.6301ZM2.4875 9.5C3.21237 9.5 3.8 10.0876 3.8 10.8125V18.6875C3.8 19.4124 3.21237 20 2.4875 20H2.3125C1.58763 20 1 19.4124 1 18.6875V10.8125C1 10.0876 1.58763 9.5 2.3125 9.5H2.4875ZM7.2125 17.2C6.77758 17.2 6.425 17.5526 6.425 17.9875C6.425 18.4224 6.77758 18.775 7.2125 18.775C7.64742 18.775 8 18.4224 8 17.9875C8 17.5526 7.64742 17.2 7.2125 17.2ZM9.75 17.2C9.31508 17.2 8.9625 17.5526 8.9625 17.9875C8.9625 18.4224 9.31508 18.775 9.75 18.775C10.1849 18.775 10.5375 18.4224 10.5375 17.9875C10.5375 17.5526 10.1849 17.2 9.75 17.2ZM12.2875 17.2C11.8526 17.2 11.5 17.5526 11.5 17.9875C11.5 18.4224 11.8526 18.775 12.2875 18.775C12.7224 18.775 13.075 18.4224 13.075 17.9875C13.075 17.5526 12.7224 17.2 12.2875 17.2ZM7.2125 14.925C6.77758 14.925 6.425 15.2776 6.425 15.7125C6.425 16.1474 6.77758 16.5 7.2125 16.5C7.64742 16.5 8 16.1474 8 15.7125C8 15.2776 7.64742 14.925 7.2125 14.925ZM9.75 14.925C9.31508 14.925 8.9625 15.2776 8.9625 15.7125C8.9625 16.1474 9.31508 16.5 9.75 16.5C10.1849 16.5 10.5375 16.1474 10.5375 15.7125C10.5375 15.2776 10.1849 14.925 9.75 14.925ZM12.2875 14.925C11.8526 14.925 11.5 15.2776 11.5 15.7125C11.5 16.1474 11.8526 16.5 12.2875 16.5C12.7224 16.5 13.075 16.1474 13.075 15.7125C13.075 15.2776 12.7224 14.925 12.2875 14.925ZM12.725 12.125H6.775C6.51727 12.125 6.30291 12.3107 6.25846 12.5556L6.25 12.65V13.35C6.25 13.6077 6.43572 13.8221 6.68063 13.8665L6.775 13.875H12.725C12.9827 13.875 13.1971 13.6893 13.2415 13.4444L13.25 13.35V12.65C13.25 12.3601 13.0149 12.125 12.725 12.125ZM10.1635 7.394L8.14936 7.39435C7.55628 7.39435 7.07549 7.87514 7.07549 8.46822L7.075 10.812H12.424L12.4245 9.79L11.5963 9.79077C10.852 9.79077 10.2404 9.22293 10.171 8.49685L10.1645 8.35896L10.1635 7.394Z",
          fill: "#FA003F",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.5 19.0028V16.489C19.5 13.5649 20.6643 10.7611 22.7356 8.69707L23.4846 7.95068",
          stroke: "#FA003F",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.834 7H24.5V11.6",
          stroke: "#FA003F",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }